import { action } from 'satcheljs';

/**
 * Surface view types -- navigate to previous week
 */
export const goToPreviousWeek = action('goToPreviousWeek');
